import { useState, useEffect } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';

const defaultAuth = {
  username: '',
  userid: null,
  roles: [],
  isAdmin: false,
  isSafetyMonitor: false,
  isLoading: true,
};

const useAuth = () => {
  const [auth, setAuth] = useState(defaultAuth);

  useEffect(() => {
    let isMounted = true;

    const loadAuth = async () => {
      let payload;
      try {
        const session = await fetchAuthSession();
        payload = session.tokens?.idToken?.payload;
      } catch (error) {
        console.error(error);
        payload = undefined;
      }

      if (!isMounted) return;

      if (!payload) {
        setAuth({ ...defaultAuth, isLoading: false });
        return;
      }

      const roles = payload['cognito:groups'] || [];
      const isAdmin = roles.includes('Admin');
      const isSafetyMonitor = roles.includes('SafetyMonitor');

      setAuth({
        username: payload.name || '',
        userid: payload.sub || null,
        roles,
        isAdmin,
        isSafetyMonitor,
        isLoading: false,
      });
    };

    loadAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  return auth;
};

export default useAuth;
